export default "__VITE_ASSET__DTPu5$4___"